import { TTLElement } from "./components/TTLElement";
import { TabMargin } from "../components/TabMargin";
import Computer from "../../Icons/Computer.icon";
import Apple2 from "../../Icons/Apple2.icon";
import Brain from "../../Icons/Brain.icon";
import React from "react";
import {
  TTLContainer,
  TTLSubtitle,
  TTLElements,
  TTLTitle,
  TTLContentWrapper,
} from "./TeachersToolkitLanding.styled";

export const TeachersToolkitLanding = ({ schoolSlug = null }) => {
  const onPortalClick = () => {
    if (!schoolSlug) {
      const searchInput = document.getElementById("school-search");
      searchInput.focus();
      return;
    }

    redirectTo(`/schools/${schoolSlug}`);
  };
  const onGuideClick = () => {
    redirectTo("/teachers-toolkit/guide");
  };
  const onBankClick = () => {
    redirectTo("/knowledge-bank");
  };

  const redirectTo = (href) => {
    const splitURL = window.location.href.split("/");
    const currentURL = splitURL
      .filter((_, index) => index < splitURL.length - 1)
      .join("/");
    window.location.href = currentURL + href;
  };

  return (
    <TTLContainer>
      <TTLContentWrapper>
        <TabMargin />
        <TTLTitle>Welcome to Teacher's Toolkit</TTLTitle>
        <TTLSubtitle>
          Start exploring our rich ecosystem of learning resources by selecting
          an option below:
        </TTLSubtitle>
        <TTLElements>
          <TTLElement
            title="School Portal"
            description="Track, visualise and analyse your school's own energy data over days, months, seasons and years."
            buttonLabel="Get Started"
            onClick={onPortalClick}
            icon={
              <Computer
                className="fill-primary "
                height="2.5rem"
                width="2.5rem"
              />
            }
          />
          <TTLElement
            title="Toolkit User Guide"
            description="Find detailed unit plans, lesson plans and student activities for all year levels, ready to use straight 'off-the-shelf'."
            buttonLabel="Access User Guide"
            onClick={onGuideClick}
            icon={
              <Apple2
                className="fill-primary "
                height="2.5rem"
                width="2.5rem"
              />
            }
          />
          <TTLElement
            title="Knowledge Bank"
            description="Give students access to references, research and resources for self-directed learning, all in one place."
            buttonLabel="Explore Now"
            onClick={onBankClick}
            icon={
              <Brain className="fill-primary " height="2.5rem" width="2.5rem" />
            }
          />
        </TTLElements>
      </TTLContentWrapper>
    </TTLContainer>
  );
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitLanding/TeachersToolkitLanding.js